module.exports = __webpack_public_path__ + "static/media/unable-to-make-contributions-02.482b9145.svg";